// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="enables-electronic-submission-and-status-tracking-of-non-medical-va-related-benefit-claims.">Enables electronic submission and status tracking of non-medical, VA-related benefit claims.</h2>
      <p>Our benefits APIs allow you to submit and track electronic benefits claims, submit PDF claims and supplemental documentation, and more. Using these APIs allows you to speed up claims processing when compared to traditional mail or fax submissions. Read the API documentation to find out which claims these APIs handle. <Link to="/release-notes/benefits">Review the latest release notes</Link>.</p>
    </div>
  );
};

export default MarkdownComponent;
